import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class ConfigurationsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getAll(): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `auth/config/`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async update(
    name: string,
    value: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `auth/config/`,
      body: {
        name, 
        value
      }
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
